import ComponentManager from '@/Management/ComponentManager';

export default class ChipsHelper {

    public static getValues<T = string>(value: string | T[]): T[] {
        if (!value)
            return [];

        if (Array.isArray(value))
            return value;

        let result = [];

        let items = value.split(';');
        let counter = 0;
        for (let i = 0; i < items.length; i++) {
            let item = items[i];

            // Die Demaskierung ist nur notwendig wenn item mit Anführungszeichen beginnt
            if (ChipsHelper.startsWith(item, '"')) {

                // Falsche Splits zusammenfuehren (Payload enthält mindestens ein Semikolon)
                // Bei einem korrekten Split muss die Anzahl der Anführungszeichen immer gerade sein.
                while (ChipsHelper.count(item, '"') % 2 === 1) {
                    i++;
                    if (i >= items.length)
                        break; // Sollte nie passieren

                    item = item + ';' + items[i];
                }

                // Entferne die umschliessenden Anführungszeichen
                item = item.substring(1, item.length - 1);

                // Entferne doppelte Anführungszeichen
                item = item.split('""').join('"');
            }

            result[counter++] = item;
        }

        return result;
    }

    public static getValuesAlphabetically<T = string>(value: string): T[] {
        const values = ChipsHelper.getValues<T>(value);

        return values.sort((a: T, b: T) => {
            let aString = a.toString();
            let bString = b.toString();

            return aString.localeCompare(bString, undefined, { numeric: true });
        });
    }

    public static maskValue(value): string {
        value = value.trim();

        // Anführungszeichen demaskieren
        value = value.split('"').join('""');

        // Bei Semikolon oder Anführungszeichen wird der Text mit Anführungszeichen umschlossen
        if (ChipsHelper.contains(value, ';') || ChipsHelper.contains(value, '"'))
            value = '"' + value + '"';

        return value;
    }

    public static getValuesAsLabel(value: string, separator: string): string {
        return ChipsHelper.getValues(value).join(separator);
    }

    private static count(text, value): number {
        return (text.match(new RegExp(value, 'g')) || []).length;
    }

    private static startsWith(text, value): boolean {
        return text.indexOf(value) === 0;
    }

    private static contains(text, value): boolean {
        return text.indexOf(value) !== -1;
    }
}

ComponentManager.setUtility('ChipsHelper', ChipsHelper, 'RADPresentation.HTMLClient.DefaultViewExtensions');